var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticClass: "j-super-query-modal",
      staticStyle: { top: "5%", "max-height": "95%" },
      attrs: {
        width: 650,
        visible: _vm.visible,
        mask: true,
        fullscreen: _vm.izMobile,
        footer: null,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "title-item" }, [_vm._v("添加标签")]),
      _c(
        "div",
        [
          _vm._l(_vm.labelList, function (item, index) {
            return _c(
              "a-checkable-tag",
              {
                key: index,
                staticClass: "tag-item",
                on: { change: () => _vm.changeTag(item) },
                model: {
                  value: item.checked,
                  callback: function ($$v) {
                    _vm.$set(item, "checked", $$v)
                  },
                  expression: "item.checked",
                },
              },
              [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
            )
          }),
          _c("div", { staticClass: "title-item" }, [_vm._v("关爱级别")]),
          _c("a-select", {
            staticStyle: {
              width: "100%",
              "margin-right": "15px",
              "margin-bottom": "20px",
            },
            attrs: {
              placeholder: "请选择关爱名单",
              options: _vm.careListOptions,
              allowClear: "",
            },
            on: { change: _vm.changeSelect },
            model: {
              value: _vm.type,
              callback: function ($$v) {
                _vm.type = $$v
              },
              expression: "type",
            },
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }